import { ReactNode } from "react";
import { MapPin2Icon } from "@/shared/icons";

type Props = {
  address: string;
  children?: ReactNode;
};
export default function Location({ address, children }: Props) {
  return (
    <div className="flex items-center gap-2.5 px-1">
      <MapPin2Icon className="size-4.5" />
      <div className="text-16 font-medium">{address}</div>
      {children}
    </div>
  );
}
